import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Sort, SortDirection } from "@angular/material/sort";
import { MessageService } from "./shared/services/message.service";
import { Message } from "./shared/models/message.model";
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { FormControl } from "@angular/forms";
import { merge } from "rxjs";
import { DetailOpenMode, DeviceTypeKeys } from "../devices/shared/models/device-types-attributes";
import { DeviceListItem } from "../devices/shared/models/device-list.model";
import { DeviceDetailComponent } from "../devices/device-detail/device-detail.component";
import { UpdateDeviceLogisticResponse } from "../devices/shared/models/device.model";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit, AfterViewInit {
  @ViewChild('messageListPaginator') private paginator!: MatPaginator;
  protected mobile: boolean = false;
  protected isLoading = true;
  protected totalCount = 0;
  protected messages = new MatTableDataSource<Message>([]);
  protected defaultSort = {active: 'date', direction: 'desc' as SortDirection};
  protected sortOptions = [
    {key: 'date', translateKey: 'messages.table.header.date'},
    {key: 'title', translateKey: 'messages.table.header.title'}
  ]
  protected searchKeywordFilter = new FormControl("");

  constructor(
    private breakpointObserver: BreakpointObserver,
    private messageService: MessageService,
  ) {
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.HandsetPortrait]).subscribe({
      next: (res) => {
        this.mobile = res.matches
      }
    })

    //this.sortData(this.defaultSort);
  }

  ngAfterViewInit() {
    this.messages.paginator = this.paginator;
    merge(this.paginator.page, this.searchKeywordFilter.valueChanges)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;
          return this.messageService.getMessages(
            this.paginator.pageIndex + 1,
            this.paginator.pageSize,
            this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value
          ).pipe(catchError(() => []));
        }),
        map((response) => {
          this.totalCount = response.totalCount;
          this.isLoading = false;
          return response.messages;
        })
      )
      .subscribe((messages) => {
        this.messages = new MatTableDataSource(messages);
      });

  }

  protected sortData(sort: Sort) {
    const asc = sort.direction === 'asc' ? 1 : -1;
    this.messages.data = this.messages.data.sort((a, b) => {
      const valA = a[sort.active as keyof Message] ?? '';
      const valB = b[sort.active as keyof Message] ?? '';
      return String(valA).localeCompare(String(valB)) * asc;
    })
  }


}
